// ToastContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { toastManager } from "./toastManager";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const handleUpdate = (newQueue) => {
      setMessages(newQueue);
    };
    
    toastManager.subscribe(handleUpdate);
    return () => toastManager.unsubscribe(handleUpdate);
  }, []);

  useEffect(() => {
    messages.forEach(m => {
      toast[m.type](m.msg, { theme: "colored"});//, autoClose: m.duration });
    });
  }, [messages]);

  return (
    <ToastContext.Provider value={{}}>
      {children}
    </ToastContext.Provider>
  );
};
